import { render, staticRenderFns } from "./StartForgotUsername.vue?vue&type=template&id=08590462&"
import script from "./StartForgotUsername.vue?vue&type=script&lang=ts&"
export * from "./StartForgotUsername.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports